import Breadcrumb from "@/components/base/Breadcrumb";
import { faqs } from "@/mocks/site";
import { usePageMeta } from "@/hooks/usePageMeta";

const values = [
  {
    icon: "ri-focus-3-line",
    title: "内容为先",
    desc: "坚持以作品与资讯本身为核心，用清晰的分类与标签帮助用户快速定位想看的内容。",
  },
  {
    icon: "ri-shield-check-line",
    title: "信息准确",
    desc: "对整理收录的影片信息与资讯内容进行核校，力求标题、简介与详情保持一致。",
  },
  {
    icon: "ri-time-line",
    title: "更新及时",
    desc: "持续跟进国产影视的上线动态与行业资讯，让内容保持新鲜与时效。",
  },
];

const team = [
  { role: "内容编辑组", desc: "负责影视作品的整理、分类与简介撰写。" },
  { role: "资讯运营组", desc: "跟踪行业动态，策划专题报道与影人访谈。" },
  { role: "产品体验组", desc: "打磨浏览、筛选与搜索体验，让查找更省心。" },
];

export default function About() {
  usePageMeta(
    "关于我们 - 国产久久久",
    "了解国产久久久的网站定位、内容理念与团队愿景，国产久久久专注国产影视作品与影视资讯的内容整理与展示。",
    "关于我们,国产久久久,国产影视,影视资讯"
  );

  return (
    <div className="w-full">
      <div className="bg-background-100 border-b border-background-200">
        <div className="w-full px-4 md:px-8 py-6 md:py-8">
          <Breadcrumb items={[{ label: "首页", path: "/" }, { label: "关于我们" }]} />
          <h1 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            关于国产久久久
          </h1>
          <p className="mt-2 text-sm text-foreground-600 max-w-2xl leading-relaxed">
            一个有温度的国产影视内容平台，专注作品整理与资讯传播。
          </p>
        </div>
      </div>

      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <section className="max-w-3xl">
          <h2 className="font-heading text-xl font-semibold text-foreground-950">
            网站定位
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-700 leading-loose">
            国产久久久致力于提供丰富且更新及时的国产影视内容，涵盖电影与电视剧两大主体分类，并结合影视资讯，满足用户对国产影视内容的多样化浏览与了解需求。我们希望通过清晰的分类、便捷的筛选与舒适的阅读体验，让每一位关注国产影视的观众都能更快找到想看的内容。
          </p>
          <p className="mt-4 text-sm md:text-base text-foreground-700 leading-loose">
            本站为内容展示与资讯平台，不提供播放、下载与支付服务。所有影视信息与资讯内容仅用于浏览与了解，具体观看方式请以官方正规渠道为准。
          </p>
        </section>

        <section className="mt-12">
          <h2 className="font-heading text-xl font-semibold text-foreground-950">
            我们的理念
          </h2>
          <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
            {values.map((item) => (
              <div
                key={item.title}
                className="rounded-lg bg-background-50 border border-background-200 p-5 md:p-6"
              >
                <span className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-50 text-primary-600 mb-4">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <h3 className="font-heading text-base font-semibold text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </section>

        <section className="mt-12">
          <h2 className="font-heading text-xl font-semibold text-foreground-950">
            团队与发展愿景
          </h2>
          <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
            {team.map((item) => (
              <div
                key={item.role}
                className="rounded-lg bg-background-100 border border-background-200 p-5 md:p-6"
              >
                <h3 className="font-heading text-base font-semibold text-foreground-950">
                  {item.role}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
          <p className="mt-6 text-sm md:text-base text-foreground-700 leading-loose max-w-3xl">
            我们期待成为一个让影迷愿意常来逛逛的国产影视内容站点：既能快速找到想看的作品，也能读到有内容的行业观察与人物故事。未来，我们将继续丰富内容品类，优化浏览体验，与更多热爱国产影视的人一起成长。
          </p>
        </section>

        <section className="mt-12 max-w-3xl">
          <h2 className="font-heading text-xl font-semibold text-foreground-950">
            常见问题
          </h2>
          <div className="mt-6 flex flex-col gap-3">
            {faqs.map((faq) => (
              <div
                key={faq.q}
                className="rounded-lg bg-background-50 border border-background-200 p-5"
              >
                <h4 className="flex items-start gap-2 font-heading text-base font-semibold text-foreground-950">
                  <span className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-[11px] shrink-0 mt-0.5">
                    Q
                  </span>
                  {faq.q}
                </h4>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed pl-7">
                  {faq.a}
                </p>
              </div>
            ))}
          </div>
        </section>

        <section className="mt-12 max-w-3xl">
          <h2 className="font-heading text-xl font-semibold text-foreground-950">
            版权声明
          </h2>
          <div className="mt-4 rounded-lg bg-background-100 border border-background-200 p-5 md:p-6">
            <p className="text-sm text-foreground-600 leading-loose">
              本站所展示的影视作品信息、图片及资讯内容均为演示数据，仅用于内容浏览与产品展示。相关影视作品、名称、图片及商标的版权归其各自权利人所有。如本站内容涉及版权问题，请通过“联系反馈”页面与我们联系，我们将及时处理。
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}